import EducationalTraningRoutes from './routes'
import 'windi.css'

export default {
  // name version 必须为字面常量
  name: 'educational-training-management-sm',
  title: '教育培训',
  version: '0.2.53',
  description: '智慧安全教育培训',
  routes: EducationalTraningRoutes, // 导出相关路由
  sysRoutes: [], // ·系统管理· 下的路由，可以为空
  dependencies: {
    // 这里记录本模块所依赖接口
    apis: [],
  },
}
